export const topicQueryKeys = (id: number) => ["topic", { id }] as const

export const topicHeaderQueryKeys = (id: number) => [...topicQueryKeys(id), "topic"] as const

export const topicContentQueryKeys = (id: number) => [...topicQueryKeys(id), "content"] as const
